import { _ as L, a as A } from "./tslib-1406810b.js";
import { f as U } from "./@smithy-2331ff76.js";
var h = 64, E = 32, _ = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), B = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
], S = Math.pow(2, 53) - 1, u = (
  /** @class */
  function() {
    function r() {
      this.state = Int32Array.from(B), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return r.prototype.update = function(f) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var s = 0, t = f.byteLength;
      if (this.bytesHashed += t, this.bytesHashed * 8 > S)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; t > 0; )
        this.buffer[this.bufferLength++] = f[s++], t--, this.bufferLength === h && (this.hashBuffer(), this.bufferLength = 0);
    }, r.prototype.digest = function() {
      if (!this.finished) {
        var f = this.bytesHashed * 8, s = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), t = this.bufferLength;
        if (s.setUint8(this.bufferLength++, 128), t % h >= h - 8) {
          for (var e = this.bufferLength; e < h; e++)
            s.setUint8(e, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var e = this.bufferLength; e < h - 8; e++)
          s.setUint8(e, 0);
        s.setUint32(h - 8, Math.floor(f / 4294967296), !0), s.setUint32(h - 4, f), this.hashBuffer(), this.finished = !0;
      }
      for (var i = new Uint8Array(E), e = 0; e < 8; e++)
        i[e * 4] = this.state[e] >>> 24 & 255, i[e * 4 + 1] = this.state[e] >>> 16 & 255, i[e * 4 + 2] = this.state[e] >>> 8 & 255, i[e * 4 + 3] = this.state[e] >>> 0 & 255;
      return i;
    }, r.prototype.hashBuffer = function() {
      for (var f = this, s = f.buffer, t = f.state, e = t[0], i = t[1], o = t[2], d = t[3], n = t[4], c = t[5], b = t[6], p = t[7], a = 0; a < h; a++) {
        if (a < 16)
          this.temp[a] = (s[a * 4] & 255) << 24 | (s[a * 4 + 1] & 255) << 16 | (s[a * 4 + 2] & 255) << 8 | s[a * 4 + 3] & 255;
        else {
          var x = this.temp[a - 2], g = (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
          x = this.temp[a - 15];
          var m = (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
          this.temp[a] = (g + this.temp[a - 7] | 0) + (m + this.temp[a - 16] | 0);
        }
        var y = (((n >>> 6 | n << 26) ^ (n >>> 11 | n << 21) ^ (n >>> 25 | n << 7)) + (n & c ^ ~n & b) | 0) + (p + (_[a] + this.temp[a] | 0) | 0) | 0, w = ((e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10)) + (e & i ^ e & o ^ i & o) | 0;
        p = b, b = c, c = n, n = d + y | 0, d = o, o = i, i = e, e = y + w | 0;
      }
      t[0] += e, t[1] += i, t[2] += o, t[3] += d, t[4] += n, t[5] += c, t[6] += b, t[7] += p;
    }, r;
  }()
), T = typeof Buffer < "u" && Buffer.from ? function(r) {
  return Buffer.from(r, "utf8");
} : U;
function v(r) {
  return r instanceof Uint8Array ? r : typeof r == "string" ? T(r) : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(r);
}
function l(r) {
  return typeof r == "string" ? r.length === 0 : r.byteLength === 0;
}
var N = (
  /** @class */
  function() {
    function r(f) {
      this.secret = f, this.hash = new u(), this.reset();
    }
    return r.prototype.update = function(f) {
      if (!(l(f) || this.error))
        try {
          this.hash.update(v(f));
        } catch (s) {
          this.error = s;
        }
    }, r.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, r.prototype.digest = function() {
      return L(this, void 0, void 0, function() {
        return A(this, function(f) {
          return [2, this.digestSync()];
        });
      });
    }, r.prototype.reset = function() {
      if (this.hash = new u(), this.secret) {
        this.outer = new u();
        var f = I(this.secret), s = new Uint8Array(h);
        s.set(f);
        for (var t = 0; t < h; t++)
          f[t] ^= 54, s[t] ^= 92;
        this.hash.update(f), this.outer.update(s);
        for (var t = 0; t < f.byteLength; t++)
          f[t] = 0;
      }
    }, r;
  }()
);
function I(r) {
  var f = v(r);
  if (f.byteLength > h) {
    var s = new u();
    s.update(f), f = s.digest();
  }
  var t = new Uint8Array(h);
  return t.set(f), t;
}
export {
  N as S
};
